// repo/primary-care-connect/frontend/src/App.tsx
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useParams,
} from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

import ScrollToTop from "./components/ScrollToTop";
import SEO from "./components/SEO/SEO";
import HomePage from "./pages/public/Home/HomePage";

//New public page (real structure, no API wiring yet)
import FindFamilyDoctorPage from "./pages/public/FindFamilyDoctor/FindFamilyDoctorPage";
import { getFindFamilyDoctorCityPage } from "./pages/public/FindFamilyDoctor/findFamilyDoctorCityPages";

//New public profile page (UI-only for now)
import FamilyDoctorProfilePage from "./pages/public/FamilyDoctorProfile/FamilyDoctorProfilePage";

//New public request form (UI-only for now)
import PatientRequestPage from "./pages/public/PatientRequest/PatientRequestPage";
import CommunityNavigatorHelpPage from "./pages/public/CommunityNavigatorHelp/CommunityNavigatorHelpPage";
import CchohtLandingPage from "./pages/public/CCHOHT/CchohtLandingPage";

//Phase 2: Manage request (token-based status + cancel)
import ManageRequestPage from "./pages/public/ManageRequest/ManageRequestPage";

//NEW: Verified success page (after email verification redirect)
import RequestVerifiedPage from "./pages/public/RequestVerified/RequestVerifiedPage";

//NEW: Public informational page (How it Works)
import HowItWorksPage from "./pages/public/HowItWorks/HowItWorksPage";

//NEW: Public informational page (Intake Process)
import IntakeProcessPage from "./pages/public/IntakeProcess/IntakeProcessPage";

//NEW: Public informational page (For Providers)
import ForProvidersPage from "./pages/public/ForProviders/ForProvidersPage";

//NEW: Public informational page (About)
import AboutPage from "./pages/public/About/AboutPage";

//NEW: Public informational page (Privacy Policy)
import PrivacyPage from "./pages/public/Privacy/PrivacyPage";

//NEW: Public informational page (Disclaimer)
import DisclaimerPage from "./pages/public/Disclaimer/DisclaimerPage";

//NEW: Public informational page (Terms of Use)
import TermsPage from "./pages/public/Terms/TermsPage";

//NEW: Public informational page (Accessibility)
import AccessibilityPage from "./pages/public/Accessibility/AccessibilityPage";

//NEW: Public Contact page
import ContactPage from "./pages/public/Contact/ContactPage";

import PortalLoginPage from "./pages/Portal/Login/PortalLoginPage";
import PortalHomePage from "./pages/Portal/PortalHomePage";

//NEW: Role picker page (Phase-4 multi-role UX)
import SelectRolePage from "./pages/Portal/SelectRole/SelectRolePage";

//NEW: No Access page
import NoAccessPage from "./pages/Portal/NoAccess/NoAccessPage";

//NEW: Request Access page (Phase-4 approvals)
import RequestAccessPage from "./pages/Portal/RequestAccess/RequestAccessPage";

//NEW: Access Pending page
import AccessPendingPage from "./pages/Portal/AccessPending/AccessPendingPage";

import SpecialistProfileCreatePage from "./pages/Portal/SpecialistProfile/SpecialistProfileCreatePage";

//Provider-only specialist pages
import FindSpecialistPage from "./pages/Portal/FindSpecialist/FindSpecialistPage";
import SpecialistProfilePage from "./pages/Portal/SpecialistProfileView/SpecialistProfilePage";

//Family Doctor portal shell (sidebar + Outlet)
import FamilyDoctorLayout from "./pages/Portal/FamilyDoctor/FamilyDoctorLayout";

//Family Doctor portal pages (real pages)
import DashboardPage from "./pages/Portal/FamilyDoctor/Dashboard/DashboardPage";
import NewPatientRequestsPage from "./pages/Portal/FamilyDoctor/NewPatientRequests/NewPatientRequestsPage";
import PatientRequestDetailsPage from "./pages/Portal/FamilyDoctor/PatientRequestDetails/PatientRequestDetailsPage";
import ProfilePage from "./pages/Portal/FamilyDoctor/Profile/ProfilePage";
import SettingsPage from "./pages/Portal/FamilyDoctor/Settings/SettingsPage";

//New: Find Specialized Clinic (provider-only tool inside portal)
import FindSpecializedClinicPage from "./pages/Portal/FamilyDoctor/FindSpecializedClinic/FindSpecializedClinicPage";

//Super Admin portal shell + PIA-minimum pages
import SuperAdminLayout from "./pages/Portal/SuperAdmin/SuperAdminLayout";
import ApprovalsPage from "./pages/Portal/SuperAdmin/Approvals/ApprovalsPage";
import SuperAdminDashboardPage from "./pages/Portal/SuperAdmin/Dashboard/SuperAdminDashboardPage";
import SuperAdminClinicsPage from "./pages/Portal/SuperAdmin/Clinics/SuperAdminClinicsPage";
import SuperAdminClinicDetailPage from "./pages/Portal/SuperAdmin/Clinics/SuperAdminClinicDetailPage";
import CreateBasicClinicPage from "./pages/Portal/SuperAdmin/Clinics/CreateBasicClinicPage";
import SuperAdminOhtsPage from "./pages/Portal/SuperAdmin/Ohts/SuperAdminOhtsPage";
import SuperAdminOhtDetailPage from "./pages/Portal/SuperAdmin/Ohts/SuperAdminOhtDetailPage";
import SuperAdminOhtCreatePage from "./pages/Portal/SuperAdmin/Ohts/SuperAdminOhtCreatePage";
import SuperAdminActivityPage from "./pages/Portal/SuperAdmin/Activity/SuperAdminActivityPage";
import SuperAdminSystemHealthPage from "./pages/Portal/SuperAdmin/SystemHealth/SuperAdminSystemHealthPage";

//Clinic Admin portal shell
import ClinicAdminLayout from "./pages/Portal/ClinicAdmin/ClinicAdminLayout";

//NEW: Clinic Admin dashboard page (real scaffold)
import ClinicAdminDashboardPage from "./pages/Portal/ClinicAdmin/Dashboard/DashboardPage";

//NEW: Clinic Admin Manage Family Doctors page (real scaffold)
import ManageFamilyDoctorsPage from "./pages/Portal/ClinicAdmin/FamilyDoctors/ManageFamilyDoctorsPage";

//NEW: Clinic Admin Manage Specialists page (real scaffold)
import ManageSpecialistsPage from "./pages/Portal/ClinicAdmin/Specialists/ManageSpecialistsPage";

//NEW: Clinic Admin Patient Requests page (clinic-wide)
import ClinicAdminNewPatientRequestsPage from "./pages/Portal/ClinicAdmin/NewPatientRequests/NewPatientRequestsPage";

//NEW: Clinic Admin Patient Request Details page
import ClinicAdminPatientRequestDetailsPage from "./pages/Portal/ClinicAdmin/PatientRequestDetails/PatientRequestDetailsPage";

//NEW: Clinic Admin Clinic Profile page (View/Edit like Family Doctor Profile)
import ClinicProfilePage from "./pages/Portal/ClinicAdmin/ClinicProfile/ClinicProfilePage";

//NEW: Clinic Admin OHT Messages inbox
import ClinicAdminOhtMessagesPage from "./pages/Portal/ClinicAdmin/OhtMessages/OhtMessagesPage";

//Community Navigator portal shell + pages
import CommunityNavigatorLayout from "./pages/Portal/CommunityNavigator/CommunityNavigatorLayout";
import CommunityNavigatorDashboardPage from "./pages/Portal/CommunityNavigator/Dashboard/DashboardPage";
import CommunityNavigatorCasesPage from "./pages/Portal/CommunityNavigator/Cases/CasesPage";
import CommunityNavigatorCaseDetailPage from "./pages/Portal/CommunityNavigator/CaseDetail/CaseDetailPage";
import CommunityNavigatorUploadsPage from "./pages/Portal/CommunityNavigator/Uploads/UploadsPage";
import CommunityNavigatorReportsPage from "./pages/Portal/CommunityNavigator/Reports/ReportsPage";

//NEW: Provider invite acceptance page (token-based)
import AcceptInvitePage from "./pages/Portal/AcceptInvite/AcceptInvitePage";

// ✅ NEW: Hosted legal page (public)
import ClinicAdminAgreementPage from "./pages/public/Legal/ClinicAdminAgreement/ClinicAdminAgreementPage";

// ✅ NEW: Clinic Admin signup explainer (Phase 3)
import ClinicAdminSignupPage from "./pages/Portal/Signup/ClinicAdminSignupPage";

//OHT Admin portal shell + pages
import OhtAdminLayout from "./pages/Portal/OhtAdmin/OhtAdminLayout";
import OhtOverviewPage from "./pages/Portal/OhtAdmin/Overview/OverviewPage";
import OhtClinicsPage from "./pages/Portal/OhtAdmin/Clinics/ClinicsPage";
import OhtDoctorsPage from "./pages/Portal/OhtAdmin/Doctors/DoctorsPage";
import OhtProfilePage from "./pages/Portal/OhtAdmin/Profile/ProfilePage";
import OhtMessagesPage from "./pages/Portal/OhtAdmin/Messages/MessagesPage";
import OhtInsightsPage from "./pages/Portal/OhtAdmin/Insights/InsightsPage";

function FindFamilyDoctorCityRoute() {
  const { citySlug } = useParams<{ citySlug: string }>();

  if (!getFindFamilyDoctorCityPage(citySlug)) {
    return <Navigate to="/public/find-family-doctor" replace />;
  }

  return <FindFamilyDoctorPage />;
}

function PlaceholderPage({ title }: { title: string }) {
  return (
    <div
      style={{
        padding: 40,
        fontFamily: "system-ui, -apple-system, Segoe UI, sans-serif",
      }}
    >
      <SEO
        title={title}
        description={`${title} is coming soon on AcceptingMD.`}
        noIndex={true}
      />

      <h1 style={{ margin: 0 }}>{title}</h1>
      <p style={{ marginTop: 8, color: "#6b7280" }}>Coming soon.</p>
    </div>
  );
}

/**
 * Super Admin PIA-minimum IA.
 *
 * Current locked scope:
 * - Dashboard
 * - Approvals
 * - Clinics
 * - System Health
 * - Activity Log
 *
 * Deferred intentionally for PIA:
 * - Providers
 * - Analytics
 * - Billing
 * - Advanced system intelligence
 */
export default function App() {
  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <Routes>
          {/* Root -> Public Home (splash removed) */}
          <Route path="/" element={<HomePage />} />

          {/* Public routes (no login) */}
          <Route path="/cchoht" element={<CchohtLandingPage />} />
          <Route path="/public" element={<HomePage />} />
          <Route
            path="/public/find-family-doctor"
            element={<FindFamilyDoctorPage />}
          />
          <Route
            path="/public/find-family-doctor/:citySlug"
            element={<FindFamilyDoctorCityRoute />}
          />
          <Route path="/public/how-it-works" element={<HowItWorksPage />} />

          {/*NEW: Intake Process informational page */}
          <Route path="/public/intake-process" element={<IntakeProcessPage />} />

          {/*NEW: For Providers informational page */}
          <Route path="/public/for-providers" element={<ForProvidersPage />} />

          {/*NEW: About informational page */}
          <Route path="/public/about" element={<AboutPage />} />

          {/*NEW: Privacy Policy informational page */}
          <Route path="/public/privacy" element={<PrivacyPage />} />

          {/*NEW: Disclaimer informational page */}
          <Route path="/public/disclaimer" element={<DisclaimerPage />} />

          {/*NEW: Terms of Use informational page */}
          <Route path="/public/terms" element={<TermsPage />} />

          {/*NEW: Accessibility informational page */}
          <Route path="/public/accessibility" element={<AccessibilityPage />} />

          {/*NEW: Contact page */}
          <Route path="/public/contact" element={<ContactPage />} />

          {/* ✅ NEW: Hosted legal page (public) */}
          <Route
            path="/public/legal/clinic-admin-agreement"
            element={<ClinicAdminAgreementPage />}
          />

          {/* Backward-compat: old route -> new public route */}
          <Route
            path="/legal/clinic-admin-agreement"
            element={
              <Navigate to="/public/legal/clinic-admin-agreement" replace />
            }
          />

          <Route
            path="/public/family-doctor/:id"
            element={<FamilyDoctorProfilePage />}
          />
          <Route
            path="/public/family-doctor/:id/request"
            element={<PatientRequestPage />}
          />
          <Route
            path="/public/community-navigator-help"
            element={<CommunityNavigatorHelpPage />}
          />

          {/*Phase 2: token-based manage/cancel page */}
          <Route
            path="/public/manage-request/:token"
            element={<ManageRequestPage />}
          />

          {/*NEW: Verified success page (after email verification redirect) */}
          <Route
            path="/public/request-verified/:manageToken"
            element={<RequestVerifiedPage />}
          />

          <Route
            path="/public/find-clinic"
            element={<PlaceholderPage title="Find a Clinic" />}
          />
          <Route
            path="/public/find-services"
            element={<PlaceholderPage title="Find Health Services" />}
          />

          {/* Portal routes (provider access) */}
          <Route path="/portal/login" element={<PortalLoginPage />} />

          {/* ✅ Phase 3: Clinic Admin signup explainer */}
          <Route
            path="/portal/clinic-admin-signup"
            element={<ClinicAdminSignupPage />}
          />

          {/*Provider invite accept (token link from email) */}
          <Route path="/portal/accept-invite" element={<AcceptInvitePage />} />

          {/* Portal landing (routes based on status/role in the page logic) */}
          <Route path="/portal" element={<PortalHomePage />} />

          {/*Role picker (Phase-4 multi-role UX) */}
          <Route path="/portal/select-role" element={<SelectRolePage />} />

          {/* Minimal status pages */}
          <Route path="/portal/access-pending" element={<AccessPendingPage />} />
          <Route
            path="/portal/access-disabled"
            element={<PlaceholderPage title="Access Disabled" />}
          />

          {/*Approved but no active roles assigned */}
          <Route path="/portal/no-access" element={<NoAccessPage />} />

          {/*Request Clinic Admin Access (v1 locked) */}
          <Route path="/portal/request-access" element={<RequestAccessPage />} />

          {/*Super Admin Portal — PIA-minimum scope */}
          <Route path="/portal/super-admin" element={<SuperAdminLayout />}>
            {/* Landing = Dashboard */}
            <Route index element={<SuperAdminDashboardPage />} />

            {/* PIA-minimum IA routes */}
            <Route path="dashboard" element={<SuperAdminDashboardPage />} />
            <Route path="approvals" element={<ApprovalsPage />} />

            {/* Clinics */}
            <Route path="clinics" element={<SuperAdminClinicsPage />} />
            <Route
              path="clinics/create-basic"
              element={<CreateBasicClinicPage />}
            />
            <Route
              path="clinics/:clinicId"
              element={<SuperAdminClinicDetailPage />}
            />

            {/* OHTs */}
            <Route path="ohts" element={<SuperAdminOhtsPage />} />
            <Route path="ohts/create" element={<SuperAdminOhtCreatePage />} />
            <Route path="ohts/:ohtId" element={<SuperAdminOhtDetailPage />} />

            {/* PIA-minimum operational safety pages */}
            <Route path="system-health" element={<SuperAdminSystemHealthPage />} />
            <Route path="activity" element={<SuperAdminActivityPage />} />

            {/* Deferred Super Admin areas: keep old URLs safe, but out of PIA-minimum scope */}
            <Route
              path="providers"
              element={<Navigate to="/portal/super-admin/dashboard" replace />}
            />
            <Route
              path="providers/:providerId"
              element={<Navigate to="/portal/super-admin/dashboard" replace />}
            />
            <Route
              path="analytics"
              element={<Navigate to="/portal/super-admin/dashboard" replace />}
            />
            <Route
              path="analytics/*"
              element={<Navigate to="/portal/super-admin/dashboard" replace />}
            />
            <Route
              path="billing"
              element={<Navigate to="/portal/super-admin/dashboard" replace />}
            />

            {/* Backward-compat: old system route now points to System Health */}
            <Route
              path="system"
              element={
                <Navigate to="/portal/super-admin/system-health" replace />
              }
            />

            {/* Keep unknown paths safe */}
            <Route
              path="*"
              element={<Navigate to="/portal/super-admin/dashboard" replace />}
            />
          </Route>

          {/*Clinic Admin Portal */}
          <Route path="/portal/clinic-admin" element={<ClinicAdminLayout />}>
            {/* Landing = Dashboard */}
            <Route index element={<Navigate to="dashboard" replace />} />

            <Route path="dashboard" element={<ClinicAdminDashboardPage />} />

            {/* Patient Requests */}
            <Route
              path="patient-requests"
              element={<ClinicAdminNewPatientRequestsPage />}
            />
            <Route
              path="patient-requests/:requestId"
              element={<ClinicAdminPatientRequestDetailsPage />}
            />

            {/* OHT messages inbox */}
            <Route
              path="oht-messages"
              element={<ClinicAdminOhtMessagesPage />}
            />

            {/* Providers IA */}
            <Route
              path="providers"
              element={<Navigate to="providers/family-doctors" replace />}
            />
            <Route
              path="providers/family-doctors"
              element={<ManageFamilyDoctorsPage />}
            />

            {/* Specialists route kept for V2, but hidden from Clinic Admin sidebar in V1 */}
            <Route
              path="providers/specialists"
              element={<ManageSpecialistsPage />}
            />

            {/* Clinic Profile */}
            <Route path="clinic-profile" element={<ClinicProfilePage />} />

            {/* Settings */}
            <Route
              path="settings"
              element={<PlaceholderPage title="Settings" />}
            />

            {/* Keep unknown paths safe */}
            <Route
              path="*"
              element={<Navigate to="/portal/clinic-admin" replace />}
            />
          </Route>

          {/*OHT Admin Portal (real shell + nested routes) */}
          <Route path="/portal/oht-admin" element={<OhtAdminLayout />}>
            <Route index element={<OhtOverviewPage />} />
            <Route path="clinics" element={<OhtClinicsPage />} />
            <Route path="doctors" element={<OhtDoctorsPage />} />
            <Route path="insights" element={<OhtInsightsPage />} />
            <Route path="profile" element={<OhtProfilePage />} />
            <Route
              path="targets"
              element={<Navigate to="/portal/oht-admin/profile" replace />}
            />
            <Route path="messages" element={<OhtMessagesPage />} />
            <Route
              path="*"
              element={<Navigate to="/portal/oht-admin" replace />}
            />
          </Route>

          {/*Backward-compat: old /portal/oht redirects to /portal/oht-admin */}
          <Route
            path="/portal/oht"
            element={<Navigate to="/portal/oht-admin" replace />}
          />
          <Route
            path="/portal/oht/*"
            element={<Navigate to="/portal/oht-admin" replace />}
          />

          {/* Community Navigator Portal */}
          <Route
            path="/portal/community-navigator"
            element={<CommunityNavigatorLayout />}
          >
            <Route index element={<CommunityNavigatorDashboardPage />} />
            <Route
              path="dashboard"
              element={<CommunityNavigatorDashboardPage />}
            />
            <Route path="cases" element={<CommunityNavigatorCasesPage />} />
            <Route
              path="cases/:navigatorCaseId"
              element={<CommunityNavigatorCaseDetailPage />}
            />
            <Route path="uploads" element={<CommunityNavigatorUploadsPage />} />
            <Route path="reports" element={<CommunityNavigatorReportsPage />} />
            <Route
              path="*"
              element={<Navigate to="/portal/community-navigator" replace />}
            />
          </Route>

          {/*Phase-4 role landing placeholders (until these portals are built) */}
          <Route
            path="/portal/specialist"
            element={<PlaceholderPage title="Specialist Portal" />}
          />
          <Route
            path="/portal/region-admin"
            element={<PlaceholderPage title="Region Admin Portal" />}
          />
          <Route
            path="/portal/admin"
            element={<PlaceholderPage title="Admin Portal" />}
          />

          {/* Optional: if users hit deeper paths for portals not built yet, keep them in a safe place */}
          <Route
            path="/portal/specialist/*"
            element={<Navigate to="/portal/specialist" replace />}
          />
          <Route
            path="/portal/region-admin/*"
            element={<Navigate to="/portal/region-admin" replace />}
          />
          <Route
            path="/portal/admin/*"
            element={<Navigate to="/portal/admin" replace />}
          />

          {/*Family Doctor Portal (real shell + nested routes) */}
          <Route path="/portal/family-doctor" element={<FamilyDoctorLayout />}>
            <Route index element={<DashboardPage />} />

            <Route path="requests" element={<NewPatientRequestsPage />} />
            <Route
              path="requests/:requestId"
              element={<PatientRequestDetailsPage />}
            />

            {/* Backward-compat: old split navigator inbox now redirects to unified inbox */}
            <Route
              path="navigator-requests"
              element={
                <Navigate to="/portal/family-doctor/requests" replace />
              }
            />

            <Route path="find-specialist" element={<FindSpecialistPage />} />
            <Route
              path="find-specialized-clinic"
              element={<FindSpecializedClinicPage />}
            />

            <Route path="profile" element={<ProfilePage />} />
            <Route path="settings" element={<SettingsPage />} />

            <Route path="specialist/:id" element={<SpecialistProfilePage />} />
          </Route>

          {/* Backward-compat redirects */}
          <Route
            path="/portal/find-specialist"
            element={
              <Navigate to="/portal/family-doctor/find-specialist" replace />
            }
          />
          <Route
            path="/portal/specialist/:id"
            element={
              <Navigate to="/portal/family-doctor/specialist/:id" replace />
            }
          />

          {/* Admin / Portal routes */}
          <Route
            path="/portal/specialists/new"
            element={<SpecialistProfileCreatePage />}
          />
        </Routes>
      </Router>
    </HelmetProvider>
  );
}